import how_works_1 from '../../../assets/images/how_works_1.png';
import how_works_2 from '../../../assets/images/basketball_banner_2.png';
import how_works_3 from '../../../assets/images/how_works_3.png';
import how_works_4 from '../../../assets/images/basketball_banner_3.png';
// import how_works_football_1 from '../../../assets/images/how_works_football_1.png';
// import how_works_football_2 from '../../../assets/images/how_works_football_2.webp';
// import how_works_football_3 from '../../../assets/images/how_works_football_3.webp';
// import how_works_football_4 from '../../../assets/images/how_works_football_4.webp';
import { COURT_NAME } from '../../../lib/constants/globalConstant';

const howItWorksData = [
    {
        id: 1,
        heading: "CHOOSE A ZONE",
        description: `The digital replica of ${COURT_NAME} has been divided into 12 zones, with each zone earning unique point multipliers and rewards.`,
        image: how_works_1,
    },
    {
        id: 2,
        heading: "SELECT YOUR TOKENS",
        description: "Select one or more tokens in each zone - your points are aggregated across all tokens, so the more tokens you buy, the more points you earn",
        image: how_works_2,
    },
    {
        id: 3,
        heading: "SCORE POINTS",
        description: "Every action in your zone, Correct answers to in-game polls and quizzes, and published posts helps you earn points",
        image: how_works_3,
    },
    {
        id: 4,
        heading: "Earn Rewards",
        description: "Celebrate every game by unlocking amazing rewards like Dinner with the Team, Sideline Passes, and more.",
         image: how_works_4,
    },
]

export default howItWorksData